import { Add } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { faqs } from "../../constants/faqs";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const FaqSection = () => {
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 6, md: 10 }}>
        {/* LEFT CONTENT */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.8,
              borderRadius: "100px",
              bgcolor: "rgba(79,110,247,0.08)",
              border: "1px solid rgba(79,110,247,0.2)",
              mb: 3,
            }}
          >
            <Typography fontSize="0.82rem" fontWeight={600} color="#4F6EF7" letterSpacing="0.04em">
              FAQ
            </Typography>
          </Box>

          <Typography
            variant="h3"
            fontWeight={800}
            color="#0D1B4B"
            gutterBottom
            sx={{ mb: 2.5, fontSize: { xs: "1.8rem", md: "2.2rem" } }}
          >
            Frequently Asked Questions
          </Typography>

          <Typography
            variant="body1"
            color="#64748B"
            sx={{ lineHeight: 1.8, mb: 4 }}
          >
            Everything you need to know about MySchoolling —
            from platform features to onboarding and support.
          </Typography>

          {/* Contact CTA card */}
          <Box
            sx={{
              p: 4,
              borderRadius: "20px",
              background: "linear-gradient(135deg, #0D1B4B 0%, #1A2F6E 100%)",
              color: "#fff",
              display: { xs: "none", md: "block" },
            }}
          >
            <SupportAgentIcon sx={{ fontSize: 40, color: "#a5b4fc", mb: 2 }} />
            <Typography fontWeight={700} mb={1} fontSize="1.1rem">
              Still have questions?
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.65)", mb: 2.5, lineHeight: 1.7 }}>
              Our team is here to help you get started and answer any additional queries.
            </Typography>
            <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate("/contact")}
              sx={{
                bgcolor: "#fff",
                color: "#0D1B4B",
                fontWeight: 700,
                borderRadius: "50px",
                "&:hover": { bgcolor: "#EEF2FF", boxShadow: "0 8px 24px rgba(0,0,0,0.2)" },
              }}
            >
              Contact Us
            </Button>
          </Box>
        </Grid>

        {/* RIGHT ACCORDIONS */}
        <Grid item xs={12} md={8}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
              elevation={0}
              sx={{
                mb: 1.5,
                borderRadius: "16px !important",
                border: expanded === index
                  ? "1.5px solid rgba(79,110,247,0.3)"
                  : "1.5px solid rgba(13,27,75,0.07)",
                bgcolor: expanded === index ? "#fff" : "#F8FAFF",
                boxShadow: expanded === index
                  ? "0 8px 32px rgba(79,110,247,0.1)"
                  : "none",
                overflow: "hidden",
                transition: "all 0.3s ease",
                "&:hover": {
                  borderColor: "rgba(79,110,247,0.2)",
                  bgcolor: "#fff",
                },
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: expanded === index
                        ? "rgba(79,110,247,0.1)"
                        : "rgba(13,27,75,0.05)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <Add
                      sx={{
                        fontSize: 18,
                        color: expanded === index ? "#4F6EF7" : "#64748B",
                        transition: "transform 0.3s ease",
                        transform: expanded === index ? "rotate(45deg)" : "rotate(0deg)",
                      }}
                    />
                  </Box>
                }
                sx={{ px: 3, py: 2 }}
              >
                <Typography
                  fontWeight={expanded === index ? 700 : 600}
                  color={expanded === index ? "#0D1B4B" : "#1E293B"}
                  fontSize="0.97rem"
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
                <Typography
                  variant="body2"
                  color="#475569"
                  sx={{ lineHeight: 1.85, fontSize: "0.93rem" }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}

          {/* Mobile CTA */}
          <Box
            mt={5}
            p={4}
            borderRadius="20px"
            textAlign="center"
            sx={{
              display: { xs: "block", md: "none" },
              background: "linear-gradient(135deg, #0D1B4B 0%, #1A2F6E 100%)",
            }}
          >
            <Typography fontWeight={700} color="#fff" gutterBottom>
              Still have questions?
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.65)", mb: 2.5 }}>
              Our team is here to help you get started.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate("/contact")}
              sx={{
                bgcolor: "#fff",
                color: "#0D1B4B",
                fontWeight: 700,
                borderRadius: "50px",
              }}
            >
              Contact Our Team
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FaqSection;
